import { render, staticRenderFns } from "./TournamentParticipants.vue?vue&type=template&id=20828684&scoped=true"
import script from "./TournamentParticipants.vue?vue&type=script&lang=js"
export * from "./TournamentParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20828684",
  null
  
)

export default component.exports